import service from '@/utils/axios';

export const AI_ASSISTANT_API = '/dwart/an_teaching/AiClassRoom/aiAssistantGenerate';

export const AI_ASSISTANT_ENTRY_CLASS_ROOM = 'AI_CLASS_ROOM';
export const AI_ASSISTANT_ENTRY_TOOL = 'AI_TOOL';

export const AI_ASSISTANT_TYPE = {
  INSPIRE: 1,
  REFRESH: 2,
  DEEPEN: 3,
  DRAW: 4,
} as const;

export interface AiAssistantContentDTO {
  index?: number | string;
  question?: string;
  keyword?: string;
}

export interface AiAssistantGenerateResponse {
  tag?: string;
  imgUrl?: string;
  contentDTOList?: AiAssistantContentDTO[];
}

export interface AiAssistantContext {
  classScheduleId?: string;
  courseId?: string | null;
  topicId?: string;
  index?: string;
  entryEnum?: string;
}

export interface AiAssistantGenerateParams extends AiAssistantContext {
  type: number;
  tag?: string;
  question?: string;
  keyword?: string;
}

function toStringParam(value: unknown): string | undefined {
  if (value === null || value === undefined || value === '') {
    return undefined;
  }
  return String(value);
}

function buildStringPayload(params: AiAssistantGenerateParams): Record<string, string | null> {
  const body: Record<string, string | null> = {
    type: String(params.type),
    entryEnum: params.entryEnum || AI_ASSISTANT_ENTRY_CLASS_ROOM,
  };

  const classScheduleId = toStringParam(params.classScheduleId);
  const topicId = toStringParam(params.topicId);
  const index = toStringParam(params.index);
  const tag = toStringParam(params.tag);
  const question = toStringParam(params.question);
  const keyword = toStringParam(params.keyword);

  if (classScheduleId) {
    body.classScheduleId = classScheduleId;
  }
  if (params.courseId === null) {
    body.courseId = null;
  } else {
    const courseId = toStringParam(params.courseId);
    if (courseId) {
      body.courseId = courseId;
    }
  }
  if (topicId) {
    body.topicId = topicId;
  }
  if (index) {
    body.index = index;
  }
  if (tag) {
    body.tag = tag;
  }
  if (question) {
    body.question = question;
  }
  if (keyword) {
    body.keyword = keyword;
  }

  return body;
}

function parseContentList(raw: unknown): AiAssistantContentDTO[] {
  if (Array.isArray(raw)) {
    return raw as AiAssistantContentDTO[];
  }
  if (raw && typeof raw === 'object') {
    const obj = raw as Record<string, unknown>;
    const nested = obj.contentDTOList ?? obj.list ?? obj.data ?? obj.items;
    if (Array.isArray(nested)) {
      return nested as AiAssistantContentDTO[];
    }
  }
  return [];
}

export function normalizeAiAssistantResponse(res: unknown): AiAssistantGenerateResponse {
  if (res == null) {
    return {};
  }
  if (typeof res === 'object') {
    const obj = res as Record<string, unknown>;
    return {
      tag: toStringParam(obj.tag),
      imgUrl: toStringParam(obj.imgUrl),
      contentDTOList: parseContentList(obj.contentDTOList ?? obj),
    };
  }
  return {};
}

export async function requestAiAssistantGenerate(
  params: AiAssistantGenerateParams,
): Promise<AiAssistantGenerateResponse> {
  const res = await service.post(
    AI_ASSISTANT_API,
    buildStringPayload(params),
  );
  return normalizeAiAssistantResponse(res);
}
